import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://extyoehbeqntunfaboup.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4dHlvZWhiZXFudHVuZmFib3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA0MDc4NTMsImV4cCI6MjA1NTk4Mzg1M30.MQq_qpnvi0bQ61XFW4H2zpyDakjDmhJTYs9oEs8gWcI";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'admin-dashboard-auth'
  },
  global: {
    headers: {
      'X-Client-Info': 'admin-dashboard'
    }
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});
